<template>
	<v-dialog v-model="addressLookupDialog" width="425">
		<AddressLookup
			v-if="addressLookupDialog"
			:key="mountKey"
			:show-nearby-projects="false"
			:create-new-project="false"
			:initial-geo-address="initialGeoAddress"
			@close="close"
			@geoAddressSelected="onGeoAddressSelected" />
	</v-dialog>
</template>

<script setup lang="ts">
	import { ref } from "vue";
	import { GeoAddress } from "@/helpers/location";
	import AddressLookup from "@/components/location/AddressLookup.vue";

	withDefaults(
		defineProps<{
			initialGeoAddress?: GeoAddress | null;
		}>(),
		{
			initialGeoAddress: null
		}
	);

	const emit = defineEmits<{
		(e: "geoAddressSelected", geoAddress: GeoAddress): void;
	}>();

	defineExpose({
		open,
		close
	});

	const addressLookupDialog = ref(false);
	// Bumped on every open() so AddressLookup is force-remounted with fresh state even on a rapid
	// same-tick close+open, where toggling addressLookupDialog false->true nets no change and Vue
	// would otherwise reuse the existing instance (carrying stale error / permission-help state).
	const mountKey = ref(0);

	function open() {
		mountKey.value++;
		addressLookupDialog.value = true;
	}

	function close() {
		addressLookupDialog.value = false;
	}

	function onGeoAddressSelected(geoAddress: GeoAddress) {
		console.log("onGeoAddressSelected", geoAddress);
		emit("geoAddressSelected", geoAddress);
		close();
	}
</script>
